const cities = [
  { name: "Metairie", zips: "70001, 70002, 70003, 70005, 70006" },
  { name: "Kenner", zips: "70062, 70065" },
  { name: "Jefferson", zips: "70121" },
  { name: "Harahan", zips: "70123" },
  { name: "Elmwood", zips: "70123" },
];

const benefits = [
  { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from your Metairie home or Elmwood office in minutes." },
  { icon: "ri-truck-line", title: "Ship Your Documents", desc: "Use overnight shipping from any UPS or FedEx location — we handle every detail from there." },
  { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed by our team before submission to catch errors before they cause delays." },
  { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed." },
];

export default function MetairieLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white pt-6 md:pt-8 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Metairie &amp; Jefferson Parish
          </h2>
        </div>
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Metairie is the largest unincorporated community in Louisiana and one of the most economically significant suburban areas in the entire Gulf South. Straddling Jefferson Parish just west of New Orleans, it functions as the de facto commercial and residential hub for a broad swath of Louisiana professionals, medical workers, legal professionals, and executives who prefer suburban living with immediate access to the New Orleans metro economy. The Lakeside area, Metairie Road corridor, and Elmwood Business District collectively host thousands of businesses ranging from independent law firms to regional financial services headquarters.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The passport patterns here are driven by affluence and international business exposure. Metairie is home to a substantial population of legal professionals, physicians at East Jefferson General and Ochsner Medical Center, energy industry consultants, and regional business owners who travel internationally on a regular basis. These are experienced travelers who know their passport should be current — but who sometimes discover mid-trip planning that a renewal lapsed during the reduced travel years of the early 2020s. They need a fast, reliable solution that does not disrupt their business schedule.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Metairie also has a large retiree population that became active international travelers after the children left home. Grandparents visiting family in Europe, retirees on Mediterranean cruises, and snowbird travelers who divide their time between Louisiana and Caribbean destinations are all regular passport renewal clients. Many discover that their last passport was issued 15 years ago and never renewed — making them ineligible for the mail-in renewal process and requiring a full new application through an acceptance clerk.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              The proximity to both the New Orleans Passport Agency on Poydras Street and MSY airport gives Metairie residents theoretical access to fast options — but the agency appointment backlog and the complexity of the agency process often mean that Fast Passport Center is still faster, simpler, and more predictable. We eliminate the uncertainty entirely: start online, ship overnight, and your passport arrives within the timeframe you select.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Metairie, LA</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving Metairie, Jefferson Parish &amp; Greater New Orleans</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Serving Metairie, Kenner, Harahan, Elmwood &amp; Jefferson Parish
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Remote service — start online, ship your documents overnight</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  Start your order online, ship your documents overnight — no office visit required for most services. Most Metairie clients receive their passports within 2–9 business days.
                </p>
                <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap">
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Jefferson Parish — start online, ship overnight. No need to navigate the New Orleans Passport Agency appointment system.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "New Orleans", href: "/new-orleans" },
                    { name: "Kenner", href: "/kenner" },
                    { name: "Slidell", href: "/slidell" },
                    { name: "Mandeville", href: "/mandeville" },
                    { name: "Houma", href: "/houma" },
                    { name: "Baton Rouge", href: "/baton-rouge" },
                  ].map((link) => (
                    <a key={link.href} href={link.href} className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap">
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Metairie Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a key={i} href="https://fastpassportcenter.com" className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}